import { render, staticRenderFns } from "./AsideMenuLayout.vue?vue&type=template&id=60a30554"
import script from "./AsideMenuLayout.vue?vue&type=script&lang=js"
export * from "./AsideMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports